import { Button, Flex, Message } from '@workwhile/ui'
import { Page } from 'pages/layout'
import { useVndlyTimesheetContext } from '../context/VndlyTimesheetProvider'
import { FilterBar } from './FilterBar'
import { TimesheetIssues } from './TimesheetIssues/TimesheetIssues'

export function VndlyTimesheetMain() {
  const {
    state: {
      downloadState: { canDownload, isPending, isError },
    },
    actions: { downloadTimesheet },
  } = useVndlyTimesheetContext()

  return (
    <Page title="VNDLY Timesheet">
      <FilterBar />
      <TimesheetIssues />
      {isError ? (
        <Message variant="error">
          Something went wrong generating the timesheet. Please try again or
          contact WorkWhile support if the issue persists.
        </Message>
      ) : null}
      <Flex justifyContent="flex-end">
        <Button
          onClick={() => downloadTimesheet()}
          loading={isPending}
          disabled={!canDownload || isPending}
        >
          Download CSV
        </Button>
      </Flex>
    </Page>
  )
}
